export default __webpack_public_path__ + "static/media/CartHeader.a3b92f37.svg";